import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { OptionalTranslationDirectiveAbstract } from './optional-translation-directive.abstract';

@Directive({
  selector: '[shrdFtHasTranslation]'
})
export class HasTranslationDirective extends OptionalTranslationDirectiveAbstract {
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);

  @Input()
  set shrdFtHasTranslation(key: string) {
    // always clear potential previous views
    this.viewContainer.clear();

    if (this.checkLabel(key)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
